import App from './text_upload/TextUpload.svelte';

const app = new App({
	target: document.getElementById("body"),
	props: {}
});

export default app;
